import React, { useEffect, useContext } from 'react';
import { store } from '../reducer';
import { useHistory, Switch, Route, useRouteMatch } from 'react-router-dom';
import Daily from './Daily/Daily';
import Monthly from './Monthly/Monthly';
import Yearly from './Yearly/Yearly';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridGap: theme.spacing(1),
    gridTemplateRows: '100px',
    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
    },
  },
}));

const Commissions = () => {
  const classes = useStyles();
  const parentUrl = `/protected/admin/reports/operatorCommissions`;
  const {
    state,
    dispatch,
    showMessage,
    showError,
    itemsCountPerPage,
  } = useContext(store);
  const history = useHistory();
  const {
    location: { pathname },
  } = history;

  const handleDaily = () => {
    history.push(`${parentUrl}/daily`);
  };
  const handleMonthly = () => {
    history.push(`${parentUrl}/monthly`);
  };
  const handleYearly = () => {
    history.push(`${parentUrl}/yearly`);
  };

  useEffect(() => {
    pathname === parentUrl &&
      dispatch({
        type: 'CHANGE_TITLE_CATEGORY',
        payload: {
          title: 'گزارش پورسانت‌ها',
          category: 'گزارش پورسانت‌های واریزی از محل کارمزد شرکت',
        },
      });
  }, [pathname]);
  return (
    <Switch>
      <Route path={`${parentUrl}/daily`}>
        <Daily />
      </Route>
      <Route path={`${parentUrl}/monthly`}>
        <Monthly />
      </Route>
      <Route path={`${parentUrl}/yearly`}>
        <Yearly />
      </Route>
      <Route exact path={`${parentUrl}`}>
        <div className={classes.root}>
          <div onClick={handleDaily} style={{ background: '#c5cae9' }}>
            گزارش روزانه
          </div>
          <div onClick={handleMonthly} style={{ background: '#f0f4c3' }}>
            گزارش ماهیانه
          </div>
          <div onClick={handleYearly} style={{ background: '#f8bbd0' }}>
            گزارش سالیانه
          </div>
        </div>
      </Route>
    </Switch>
  );
};

export default React.memo(Commissions);
